module.exports = __webpack_public_path__ + "images/2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/slider/2.jpg
 ** module id = 634
 ** module chunks = 0
 **/